export default function getUserInitialsData(session) {
  if (session?.code === 401) return false
  let data = session?.email?.charAt(0)
  if (session?.firstname && session?.lastname) {
    data = `${session.firstname.charAt(0)}${session.lastname.charAt(0)}`
  }
  return data
}
